import flyd from "flyd"

const Messages = flyd.stream ();

export default Messages;
